/**
 * The Datadog browser SDK reports every uncaught error on the page, including
 * errors thrown by browser extensions and by email link scanners that open our
 * public pages. These errors are not ours and only trigger alerts.
 */

const ignoredMessages = [
  "ResizeObserver",
  // Microsoft Outlook / Defender Safe Links scanner, which opens links from emails.
  "Object Not Found Matching Id",
];

const extensionSchemes = [
  "chrome-extension://",
  "moz-extension://",
  "safari-extension://",
  "safari-web-extension://",
];

export interface ReportedError {
  message?: string;
  stack?: string;
}

const isFromExtensionOnly = (stack: string, appOrigin: string) =>
  extensionSchemes.some((scheme) => stack.includes(scheme)) &&
  !stack.includes(appOrigin);

export const isDatadogNoise = (
  errors: ReadonlyArray<ReportedError>,
  appOrigin: string,
) =>
  errors.some(
    ({ message, stack }) =>
      ignoredMessages.some(
        (ignored) => message?.includes(ignored) || stack?.includes(ignored),
      ) ||
      (stack !== undefined && isFromExtensionOnly(stack, appOrigin)),
  );
